import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import 'normalize.css/normalize.css';
import Root from './components/root';
import configure from './store';
import './index.css';

injectTapEventPlugin();
const store = configure();

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider>
      <Root />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js